/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1StatByDriversData } from '../../entities/v1/StatByDriversData'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1StatByDriversDataSchema = z.object({
  card_amount: z.number(),
  cash_amount: z.number(),
  company_reward: z.number(),
  done_orders: z.number().int(),
  drivee_commission: z.number(),
  driver_id: z.number().int(),
  driver_revenue: z.number(),
  orders_amount: z.number(),
  phone: z.string(),
  rides_duration_sec: z.number().int(),
}) as unknown as ToZod<V1StatByDriversData>